import { render, staticRenderFns } from "./RegulationsRefund.vue?vue&type=template&id=55bb91b4&"
import script from "./RegulationsRefund.vue?vue&type=script&lang=js&"
export * from "./RegulationsRefund.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports